module.exports = __webpack_public_path__ + "img/blue_173.302a9608.png";